// Pieniądze trzymamy w groszach (integer). 250 = 2,50 PLN.
//
// API:
//   formatPLN(minor)                  → "2,50 zł"           (default symbol+, sign-)
//   formatPLN(minor, {symbol:false})  → "2,50"
//   formatPLN(-150, {sign:true})      → "−1,50 zł"
//   formatPLN(150, {sign:true})       → "+1,50 zł"
//   minorToZl(minor)                  → "2,50"              (no symbol, no sign — stary alias do form input)
//   parsePLN(input)  / zlToMinor(input) → 250 | null
//   parsePLN(input, { max })           → null jeśli |minor| > max

type FormatOpts = { sign?: boolean; symbol?: boolean };

/** Domyślny ceiling — 1 mln zł. Chroni warstwy bez własnego max
 *  (np. transaction.amountMinor) przed abusy'owymi payloadami z DevTools.
 *  Call-sites mogą podać tighter max (np. chore reward = 10k zł). */
const DEFAULT_MAX_MINOR = 1_000_000_00;

export function formatPLN(minor: number, opts?: FormatOpts): string {
  const { sign = false, symbol = true } = opts ?? {};
  const sgn = minor < 0 ? "−" : sign && minor > 0 ? "+" : "";
  const abs = Math.abs(minor);
  const z = (abs / 100).toFixed(2).replace(".", ",");
  return symbol ? `${sgn}${z} zł` : `${sgn}${z}`;
}

export function minorToZl(minor: number): string {
  return (minor / 100).toFixed(2).replace(".", ",");
}

export function parsePLN(
  input: string,
  opts?: { max?: number },
): number | null {
  const cleaned = input
    .replace(/\s|zł/gi, "")
    .replace("−", "-")
    .replace(",", ".");
  if (!/^-?\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const n = Number.parseFloat(cleaned);
  if (Number.isNaN(n)) return null;
  const minor = Math.round(n * 100);
  const max = opts?.max ?? DEFAULT_MAX_MINOR;
  if (Math.abs(minor) > max) return null;
  return minor;
}

// Alias dla zachowania starych call-sites — przyjmuje ten sam opts
export const zlToMinor = parsePLN;
